import React ,{useEffect, useState} from 'react';
import { loadDispensedData, loadPaidClaimsDetails } from '../../Services/loadOrder';
import { useNavigate } from 'react-router-dom';
import MenuBar from './MenuBar';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ChevronLeft, ChevronRight, Flag } from 'lucide-react';
import "../../assets/css/home.css";
import toast, {Toaster} from 'react-hot-toast';
import { exportToExcel } from '../../utils/exportToExcel';
import { FaFileExcel } from 'react-icons/fa';
import Button from '@mui/material/Button';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const PaidClaims = () => {
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();
    const [names, setNames] = useState([]); // For dropdown values
    const [selectedName, setSelectedName] = useState("");
    const [searchText, setSearchText] = useState("");
    const [searchLoading, setSearchLoading] = useState(false);
    const today = new Date().toISOString().slice(0, 10);
    const thirtyDaysAgo = new Date(Date.now() - 31 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
    const [startDate, setStartDate] = useState(thirtyDaysAgo);
    const [endDate, setEndDate] = useState(today);
    const [loading, setLoading] = useState(true); 

    const user = JSON.parse(localStorage.getItem('user'));
    
    useEffect(() => {
        const searchFields = columns.map(col => ({
          label: col.headerName,
          field: col.searchField || col.field
        }));
        setNames(searchFields);
    }, []);
      
  //HANDLE SEARCH FUNCTION
  
  const handleSearch = async () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const pharmacyId = user?.pharmacyId;
  const userId = user?.userId;

  if (!pharmacyId || !userId) {
    toast.error("Missing pharmacy or user info. Please login again.");
    return;
  }

  setSearchLoading(true);
  try {
    let orderResponse;
    // If no search field or text, search by date only
    if (!selectedName && !searchText) {
      orderResponse = await loadDispensedData(2, pharmacyId, "", "", startDate, endDate, userId);
      console.log("Calling loadOrder with params:", {
        Flag: 2,
        PharmID: pharmacyId,
        Column: "",
        Value: "",
        FromDate: startDate,
        ToDate: endDate,
        UserID: userId,
      });

      if (orderResponse.success && Array.isArray(orderResponse.data)) {
      const formattedRows = orderResponse.data.map((item, index) => ({
        id: index + 1,
        checkNumber: item.CheckNumber,
        paidAmount: item.PaidAmount,
        noofClaims: item.NoofClaims,
        submissionStartDate: item.SubmissionStartDate,
        submissionEndDate: item.SubmissionEndDate,
        paidDate: item.PaidDate
          ? new Date(item.PaidDate).toLocaleDateString()
          : '',
        memberId: item.MemberID,
        PharmacyID: item.PharmacyID,
        contract: item.Contract,
        userId,
      }));
      setRows(formattedRows);
    } else {
      setRows([]);
      toast.error("No data found for the search.");
    }
    } else {
      orderResponse = await loadDispensedData(2, pharmacyId, selectedName, searchText, startDate, endDate, userId);
      console.log("Calling loadOrder with params:", {
        Flag: 2,
        PharmID: pharmacyId,
        Column: selectedName,
        Value: searchText,
        FromDate: startDate,
        ToDate: endDate,
        UserID: userId,
      });

      if (orderResponse.success && Array.isArray(orderResponse.filterData)) {
      const formattedRows = orderResponse.filterData.map((item, index) => ({
        id: index + 1,
        checkNumber: item.CheckNumber,
        paidAmount: item.PaidAmount,
        noofClaims: item.NoofClaims,
        submissionStartDate: item.SubmissionStartDate,
        submissionEndDate: item.SubmissionEndDate,
        paidDate: item.PaidDate
          ? new Date(item.PaidDate).toLocaleDateString()
          : '',
        memberId: item.MemberID,
        PharmacyID: item.PharmacyID,
        contract: item.Contract,
        userId,
      }));
      setRows(formattedRows);
    } else {
      setRows([]);
      toast.error("No data found for the search.");
    }
    }

    
  } catch (error) {
    toast.error("Error searching cost share details.");
  } finally {
    setSearchLoading(false);
  }
};


    

// field: 'authNo', headerName: 'Auth No', flex: 1, headerClassName: 'pink-header'
    const columns = [{ field: 'checkNumber', headerName: 'Check Number', flex:1, headerClassName: 'pink-header' },
    { field: 'paidAmount', headerName: 'Paid Amount', flex:1, headerClassName: 'pink-header' },
    { field: 'noofClaims', headerName: 'No Of Claims',flex:1, headerClassName: 'pink-header' },
    { field: 'submissionStartDate', headerName: 'Submission Start Date',flex:1, headerClassName: 'pink-header' },
    { field: 'submissionEndDate', headerName: 'Submission End Date', flex:1, headerClassName: 'pink-header' },
    { field: 'paidDate', headerName: 'Paid Date', flex:1, headerClassName: 'pink-header' },
    { field: 'memberId', headerName: 'Member ID',flex:1, headerClassName: 'pink-header' },  
    { field: 'PharmacyID', headerName: 'Pharmacy ID', flex:1, headerClassName: 'pink-header' },
    { field: 'contract', headerName: 'Contract', flex:1.5, headerClassName: 'pink-header',
       renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  )
     },
       
]
    
    useEffect(() =>{
        const fetchData = async () => {
            const user = JSON.parse(localStorage.getItem('user'));
            const pharmacyId = user?.pharmacyId;
            const userId = user?.userId;
            if (!pharmacyId) return;

            const orderResponse = await loadDispensedData(2, 
              pharmacyId, "", "", thirtyDaysAgo, today, userId);
            if (orderResponse.success) {
                const formattedRows = orderResponse.data.map((item, index) => ({
                    id: index + 1,
                    checkNumber: item.CheckNumber,
                    paidAmount: item.PaidAmount,
                    noofClaims: item.NoofClaims,
                    submissionStartDate: item.SubmissionStartDate,
                    submissionEndDate: item.SubmissionEndDate,
                    paidDate: item.PaidDate
                        ? new Date(item.PaidDate).toLocaleDateString()
                        : '',
                    memberId: item.MemberID,
                    PharmacyID: item.PharmacyID,
                    contract: item.Contract,        
                    userId,     
                    
                }));
                setRows(formattedRows);
            }
            setLoading(false);
            
        };
        fetchData();
    },[]);

    const handleRowClick = async (params) => {
  const row = params.row;

  const contract = row.contract;
  const taskId = row.taskId;
  const pharmacyId = row.PharmacyID;
  const userId = row.userId;
  const checkNumber = row.checkNumber;
  console.log("Calling loadRxDetails with:", { checkNumber,  pharmacyId, contract});


  if (!contract || !pharmacyId || !userId) {
    toast.error("Missing required task or user data.");
    return;
  }

  try {
    const rxResponse = await loadPaidClaimsDetails(checkNumber,  pharmacyId, contract, "", "" );
    console.log("Prescription details response:", rxResponse?.data);

    if (rxResponse?.data) {
      navigate('/paid-task-grid', {
        state: {
          checkNumber,
          contract,
          pharmacyId,
          userId,
          rxData: rxResponse
        }
      });
    } else {
      toast.error("No prescription data found.");
    }
  } catch (err) {
    console.error("Failed to load prescription details:", err);
    toast.error("Error loading prescription details.");
  }
};

    return (
        <div>
            <MenuBar/>
            <Toaster position='top-right'/>
            <div className='top-page-option'>
        <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center' }}>
          <a 
            href="#/home" 
            style={{
              textDecoration: 'none',
              color: '#ec088c',
              display: 'inline-flex',
              alignItems: 'center'
            }}
          >
            <ChevronLeft color='#ec088c' size={18} />
            <span style={{ marginLeft: '5px' }}>Back</span>
          </a>
        </div>

        
        <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                          <span> Dispensed Orders</span>
                                          <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }} />
                                          <span>Paid Claims</span>
                                       

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: 'auto', marginRight: '6.3%' }}>
            {/* Dropdown, Textbox, and Search Button */}
            <div style={{ marginLeft: "auto" ,justifyContent:'right'}}>
                 <input type="date" style={{ padding: '5px',border: '1px solid rgb(236, 151, 202)',
          borderRadius: '15px', fontFamily: 'Calibri',
   fontSize: '12px',outline: 'none',
        transition: 'all 0.3s ease'
      }}
      onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid rgb(236, 151, 202)';
        e.target.style.boxShadow = '0 1px 2px rgb(236, 151, 202)';
      }} value={startDate} onChange={e => setStartDate(e.target.value)} />
                </div>


            <div style={{ marginLeft: "0px" }}>
                 <input type="date" style={{ padding: '5px', border: '1px solid rgb(236, 151, 202)',
          borderRadius: '15px', fontFamily: 'Calibri',
   fontSize: '12px', outline: 'none',
        transition: 'all 0.3s ease'
      }}
      onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid rgb(236, 151, 202)';
        e.target.style.boxShadow = '0 1px 2px rgb(236, 151, 202)';
      }} value={endDate} onChange={e => setEndDate(e.target.value)} />
                </div>
         

<FormControl size="small" sx={{ minWidth: 100, height: '30px', background: '#fff', borderRadius: '4px', marginRight: '10px' }}>
      <InputLabel sx={{ fontFamily: 'Calibri', marginBottom: '10px'
        , background: '#fff', color: 'black', fontSize: '12px'}}>--Select--</InputLabel>
      <Select
        value={selectedName}
        onChange={(e) => setSelectedName(e.target.value)}
        label="Select"
        sx={{
          fontFamily: 'Segoe ui',
          fontSize: '12px',
          border: '1px solid rgb(236, 151, 202)',
          borderRadius: '15px',
          height: '30px',
          boxShadow: 'none',
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ec008c',
            boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ec008c',
          },
          
        }}
      >
        <MenuItem value=""
        sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#f5f5f5' } }}>
          --Select--</MenuItem>
        <MenuItem value="checkNumber"sx={{fontSize: '12px',  '&:hover': { backgroundColor: '#f5f5f5' } }}>
        CheckNumber</MenuItem>
        <MenuItem value="paidAmount" sx={{fontSize: '12px',  '&:hover': { backgroundColor: '#f5f5f5' } }}>
        PaidAmount</MenuItem>
        <MenuItem value="submissionStartDate" sx={{fontSize: '12px',  '&:hover': { backgroundColor: '#f5f5f5' } }}>
        SubmissionStartDate</MenuItem>
        <MenuItem value="submissionEndDate" sx={{fontSize: '12px',  '&:hover': { backgroundColor: '#f5f5f5' } }}>
        SubmissionEndDate</MenuItem>
        <MenuItem value="memberID" sx={{fontSize: '12px',  '&:hover': { backgroundColor: '#f5f5f5' } }}>
        MemberID</MenuItem>
        <MenuItem value="paidDate" sx={{fontSize: '12px',  '&:hover': { backgroundColor: '#f5f5f5' } }}>
        PaidDate</MenuItem>
      </Select>
    </FormControl>


            <input
              type="text"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') handleSearch(); }}
              style={{ padding: '5px 5px', border: '1px solid rgb(236, 151, 202)',
          borderRadius: '15px', outline: 'none',
        transition: 'all 0.3s ease'
      }}
      onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid rgb(236, 151, 202)';
        e.target.style.boxShadow = '0 1px 2px rgb(236, 151, 202)';
      }}
            />
            <button
              onClick={handleSearch}
              disabled={searchLoading}
              style={{ padding: '6px 18px', borderRadius: '4px', background: '#ec008c', color: 'white', border: 'none', cursor: 'pointer' }}
            >
              {searchLoading ? <>
                    Searching&nbsp;&nbsp;
                    <CircularProgress size={15} sx={{ color: '#fff' }} />
                  </> : 'Search'}
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{ padding: '5px 18px', borderRadius: '4px', background: '#ec008c', color: 'white', border: 'none', cursor: 'pointer' }}
            >
              View All
            </button>
          </div>
           </div>
      </div>

      {columns && columns.length > 0 && (
       <div style={{ height: '60vh', width: '85%', margin: 'auto' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[10, 25, 50]}
          disableSelectionOnClick
          onRowClick={handleRowClick}
                             
          sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': {
              color: '#fff',
              backgroundColor: '#ec008c',
              fontWeight: 'bold',
              whiteSpace: 'normal',         // allow wrapping
              wordBreak: 'break-word',      // break long words
              overflowWrap: 'break-word',   // break long words
              lineHeight: 1.2,
              textAlign: 'center',          // optional: center header text
              padding: '8px 2px',
            },
            
            // '& .locked-task-row': {
            //   backgroundColor: 'rgb(233, 230, 230) !important',
            //   color: 'black'
            // }
             '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5 !important',
              cursor: 'pointer',
            },// Remove blue outline on cell focus
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
    // Remove blue outline on column header focus
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
          }}
        />
      </div>)}


<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '85%', margin: '10px auto 0 auto' }}>
  <Button
    variant="outlined"
    onClick={() => {
      // Prepare columns for export (remove renderHeader, renderCell, etc.)
      const exportColumns = columns.map(({ field, headerName }) => ({ field, headerName }));
      // Prepare rows for export
      exportToExcel(exportColumns, rows, 'PaidClaims');
    }}
    sx={{ mb: 1, minWidth: 0, p: 0.5 }}
  >
    <FaFileExcel style={{ width: 30, height: 35 , color: '#008000'}} title="Download XLSX" alt="Excel" />
  </Button>
</div>

{/* Unified spinner overlay for loading and searching */}
{(loading || searchLoading) && (
    <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(255,255,255,0.7)',
            zIndex: 2000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{
              border: '6px solid #f3f3f3',
              borderTop: '6px solid #EC088C',
              borderRadius: '50%',
              width: 48,
              height: 48,
              animation: 'spin 1s linear infinite'
            }} />
            <div style={{marginTop: 24, fontSize: '1.2rem', fontWeight: 500, color: '#222'}}>Your request is being processed</div>
            <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
          </div>
)}
           
        </div>
    );
};

export default PaidClaims;